module.exports = __webpack_public_path__ + "static/media/logo@2x.db752449.png";